export default "__VITE_ASSET__IPCsYNLT__"